import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { AddOrganisationToEventDto } from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const addOrganisationToEvent = async ({
  orgId,
  eventId,
  payload,
}: {
  orgId: string;
  eventId: string;
  payload: AddOrganisationToEventDto;
}) => {
  const response = await axiosClient.post(
    `${orgId}/events/${eventId}/organisations`,
    payload,
  );
  return response.data;
};

export function useAddOrganisationToEvent(
  queryOptions?: UseMutationOptions<
    void,
    HttpError,
    { orgId: string; eventId: string; payload: AddOrganisationToEventDto }
  >,
) {
  return useMutation({
    mutationFn: addOrganisationToEvent,
    ...queryOptions,
  });
}
